import React from 'react'

export default ({ error }) =>
  error &&
  (
    <div className="alert alert-danger t3">
      {error}
    </div>
  ) || null
